import { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { usePushNotifications } from '@/hooks/usePushNotifications';

/**
 * Silent component that auto-subscribes to push notifications
 * after the user logs in (if they've already granted permission).
 */
export default function PushAutoSubscribe() {
  const { user } = useAuth();
  const { supported, permission, subscribed, subscribe } = usePushNotifications();
  const attempted = useRef(false);

  useEffect(() => {
    if (!user || !supported || subscribed || attempted.current) return;
    // Only auto-subscribe if permission was already granted (don't prompt)
    if (permission === 'granted') {
      attempted.current = true;
      subscribe().catch(() => {});
    }
  }, [user, supported, permission, subscribed, subscribe]);

  return null;
}
